(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e6c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e6c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8KvCN", function(module, exports) {

$parcel$export(module.exports, "initClientFeedback", () => $65eb26a5e53d8e01$export$120e3e4e0ce7ffb6);
$parcel$export(module.exports, "removeClientFeedback", () => $65eb26a5e53d8e01$export$aeef28c7ed6d6680);
/**
 * KHERD-Client — the limited, public feedback bar on a client's STAGING site
 * (*.pilotpractice.cloud). Anyone who is not staff can point at an element and
 * leave a comment; that is all it does. No task, no AI, no edits: every comment
 * waits for our team to approve it in the staff KloudHerd bar
 * (Roy + Christelle, 2026-10-22, task 182083).
 *
 * Teal, labelled "Client feedback", so it never reads as our staff KloudHerd.
 * Steps aside the moment a staff session exists (the staff bar removes it too).
 */ 
var $ainy6 = parcelRequire("ainy6");
const $65eb26a5e53d8e01$var$API_BASE = `${"https://app.pilotpractice.com"}/api/site-feedback/client`;
const $65eb26a5e53d8e01$var$TAG = 'kloudmd-client-feedback';
const $65eb26a5e53d8e01$var$NAME_KEY = 'kmd_client_fb_author';
const $65eb26a5e53d8e01$var$STAGING = /(^|\.)pilotpractice\.cloud$/i;
const $65eb26a5e53d8e01$var$TEAL = '#0f766e';
const $65eb26a5e53d8e01$var$Z = 2147483646;
function $65eb26a5e53d8e01$export$120e3e4e0ce7ffb6() {
    try {
        if (window.self !== window.top) return;
        if (!$65eb26a5e53d8e01$var$STAGING.test(window.location.hostname)) return;
        if (window.__kmdClientFeedback || window.__kmdSiteFeedback) return;
        if (document.querySelector('kloudmd-feedback') || document.querySelector($65eb26a5e53d8e01$var$TAG)) return;
        if ($65eb26a5e53d8e01$var$hasStaffSession()) return;
        const q = new URLSearchParams(window.location.search);
        if (q.has('kmd_review') || q.has('elementor-preview') || q.has('customize_changeset_uuid') || q.get('et_fb') === '1') return;
        window.__kmdClientFeedback = true;
        // The Chrome extension seeds the staff session a moment after load — give it
        // that moment so a staff browser never flashes the client bar.
        setTimeout(()=>{
            try {
                if ($65eb26a5e53d8e01$var$hasStaffSession() || window.__kmdSiteFeedback || document.querySelector('kloudmd-feedback')) return;
                $65eb26a5e53d8e01$var$mount();
            } catch (e) {}
        }, 1500);
    } catch (e) {
    // Never break a client page.
    }
}
function $65eb26a5e53d8e01$var$hasStaffSession() {
    try {
        const s = JSON.parse(localStorage.getItem('kmd_site_review') || 'null');
        return !!(s && s.token);
    } catch (e) {
        return false;
    }
}
function $65eb26a5e53d8e01$var$siteToken() {
    return document.querySelector('script[id="pilotpractice-widget-script-js"], script[src*="assets/js/script.js"], script[data-id="assistant"]')?.getAttribute('data-token') || null;
}
function $65eb26a5e53d8e01$var$pageUrl() {
    const u = new URL(window.location.href);
    u.searchParams.delete('kmd_pin');
    return u.toString();
}
async function $65eb26a5e53d8e01$var$request(method, path, body) {
    const res = await fetch(`${$65eb26a5e53d8e01$var$API_BASE}/${path}`, {
        method: method,
        headers: {
            Accept: 'application/json',
            ...body ? {
                'Content-Type': 'application/json'
            } : {}
        },
        body: body ? JSON.stringify(body) : undefined
    });
    const data = await res.json().catch(()=>({}));
    if (!res.ok) throw Object.assign(new Error(data.message || 'Request failed'), {
        status: res.status
    });
    return data;
}
function $65eb26a5e53d8e01$var$mount() {
    const host = document.createElement($65eb26a5e53d8e01$var$TAG);
    host.style.cssText = `all:initial;position:fixed;inset:0;pointer-events:none;z-index:${$65eb26a5e53d8e01$var$Z};`;
    const root = host.attachShadow({
        mode: 'open'
    });
    root.innerHTML = `
      <style>
        * { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
        /* Vertical tab on the right edge, mid-height: clear of the booking launcher and the
           accessibility button that both sit in the bottom corners. */
        .bar { position: fixed; right: 0; top: 50%; transform: translateY(-50%); display: flex; flex-direction: column; align-items: stretch; pointer-events: auto; }
        .bar .btn.start { writing-mode: vertical-rl; transform: rotate(180deg); border-radius: 0 10px 10px 0; padding: 16px 10px; box-shadow: -2px 4px 16px rgba(15,118,110,.35); }
        .bar .badge { display: none; }
        .btn { background: ${$65eb26a5e53d8e01$var$TEAL}; color: #fff; border: 0; border-radius: 999px; padding: 11px 18px; font-size: 14px; font-weight: 600; cursor: pointer; box-shadow: 0 6px 20px rgba(15,118,110,.35); }
        .btn:hover { background: #115e59; }
        .btn.ghost { background: #fff; color: ${$65eb26a5e53d8e01$var$TEAL}; border: 1.5px solid ${$65eb26a5e53d8e01$var$TEAL}; box-shadow: none; }
        .badge { background: #fff; color: ${$65eb26a5e53d8e01$var$TEAL}; border: 1.5px solid ${$65eb26a5e53d8e01$var$TEAL}; border-radius: 999px; padding: 3px 9px; font-size: 11px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; }
        .hint { position: fixed; top: 16px; left: 50%; transform: translateX(-50%); background: ${$65eb26a5e53d8e01$var$TEAL}; color: #fff; padding: 9px 16px; border-radius: 8px; font-size: 14px; display: none; pointer-events: auto; box-shadow: 0 6px 20px rgba(0,0,0,.2); }
        .hint button { margin-left: 10px; background: transparent; color: #fff; border: 1px solid rgba(255,255,255,.6); border-radius: 6px; padding: 3px 9px; cursor: pointer; font-size: 13px; }
        .hl { position: fixed; border: 2px solid ${$65eb26a5e53d8e01$var$TEAL}; background: rgba(15,118,110,.08); border-radius: 3px; display: none; pointer-events: none; }
        .marker { position: fixed; width: 26px; height: 26px; margin: -13px 0 0 -13px; border-radius: 50% 50% 50% 4px; background: ${$65eb26a5e53d8e01$var$TEAL}; color: #fff; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; border: 2px solid #fff; box-shadow: 0 2px 8px rgba(0,0,0,.3); cursor: pointer; pointer-events: auto; }
        .marker.sent { background: #64748b; }
        .card { position: fixed; width: 320px; max-width: calc(100vw - 24px); background: #fff; color: #0f172a; border-radius: 12px; box-shadow: 0 12px 40px rgba(0,0,0,.25); border-top: 4px solid ${$65eb26a5e53d8e01$var$TEAL}; padding: 14px; display: none; pointer-events: auto; font-size: 14px; }
        .card h4 { margin: 0 0 8px; font-size: 14px; color: ${$65eb26a5e53d8e01$var$TEAL}; }
        .card textarea, .card input { width: 100%; border: 1px solid #cbd5e1; border-radius: 8px; padding: 8px 10px; font-size: 14px; margin-bottom: 8px; color: #0f172a; background: #fff; }
        .card textarea { min-height: 90px; resize: vertical; }
        .card textarea:focus, .card input:focus { outline: 2px solid ${$65eb26a5e53d8e01$var$TEAL}; outline-offset: 0; border-color: ${$65eb26a5e53d8e01$var$TEAL}; }
        .card .row { display: flex; gap: 8px; justify-content: flex-end; }
        .card .note { font-size: 12px; color: #475569; margin: 0 0 8px; }
        .card .meta { font-size: 12px; color: #475569; margin-top: 6px; }
        .card .hp { position: absolute; left: -9999px; width: 1px; height: 1px; opacity: 0; }
        .toast { position: fixed; left: 50%; bottom: 80px; transform: translateX(-50%); background: #0f172a; color: #fff; padding: 10px 16px; border-radius: 8px; font-size: 14px; display: none; pointer-events: none; }
        @media (max-width: 600px) { .bar .btn.start { padding: 12px 8px; font-size: 13px; } }
      </style>
      <div class="hl"></div>
      <div class="markers"></div>
      <div class="hint">Click the part of the page you want to comment on <button type="button" class="cancel-pick">Cancel</button></div>
      <div class="card form" role="dialog" aria-label="Leave feedback">
        <h4>Your feedback</h4>
        <p class="note">Our team reviews every comment before any change is made.</p>
        <label class="hp" aria-hidden="true">Website <input class="website" tabindex="-1" autocomplete="off"></label>
        <textarea class="comment" placeholder="What would you like changed here?" aria-label="Comment" maxlength="3000"></textarea>
        <input class="author" placeholder="Your name (optional)" aria-label="Your name" maxlength="120">
        <input class="email" type="email" placeholder="Your email (optional)" aria-label="Your email" maxlength="190">
        <div class="row"><button type="button" class="btn ghost cancel">Cancel</button><button type="button" class="btn send">Send feedback</button></div>
      </div>
      <div class="card tip" role="tooltip"></div>
      <div class="toast" role="status" aria-live="polite"></div>
      <div class="bar"><span class="badge">Client feedback</span><button type="button" class="btn start" aria-label="Leave feedback on this page">Leave feedback</button></div>
    `;
    (document.body || document.documentElement).appendChild(host);
    const $ = (s)=>root.querySelector(s);
    const hl = $('.hl'), hint = $('.hint'), form = $('.form'), tip = $('.tip'), toast = $('.toast'), markersEl = $('.markers');
    let picking = false, target = null, clickPt = null, pins = [];
    try {
        const saved = JSON.parse(localStorage.getItem($65eb26a5e53d8e01$var$NAME_KEY) || 'null');
        if (saved) {
            $('.author').value = saved.name || '';
            $('.email').value = saved.email || '';
        }
    } catch (e) {}
    const showToast = (msg)=>{
        toast.textContent = msg;
        toast.style.display = 'block';
        clearTimeout(showToast.t);
        showToast.t = setTimeout(()=>{
            toast.style.display = 'none';
        }, 3500);
    };
    const place = (el, x, y)=>{
        const w = el.offsetWidth || 320, h = el.offsetHeight || 220;
        el.style.left = Math.max(12, Math.min(x + 14, window.innerWidth - w - 12)) + 'px';
        el.style.top = Math.max(12, Math.min(y + 14, window.innerHeight - h - 12)) + 'px';
    };
    const isOurs = (el)=>el === host || el && host.contains(el);
    function onMove(e) {
        if (!picking) return;
        const el = document.elementFromPoint(e.clientX, e.clientY);
        if (!el || isOurs(el)) {
            hl.style.display = 'none';
            return;
        }
        const r = el.getBoundingClientRect();
        Object.assign(hl.style, {
            display: 'block',
            left: r.left + 'px',
            top: r.top + 'px',
            width: r.width + 'px',
            height: r.height + 'px'
        });
    }
    function onPick(e) {
        if (!picking) return;
        const el = document.elementFromPoint(e.clientX, e.clientY);
        if (!el || isOurs(el)) return;
        e.preventDefault();
        e.stopPropagation();
        const r = el.getBoundingClientRect();
        target = el;
        clickPt = {
            x_pct: r.width ? Math.round((e.clientX - r.left) / r.width * 1000) / 10 : 50,
            y_pct: r.height ? Math.round((e.clientY - r.top) / r.height * 1000) / 10 : 50
        };
        stopPicking();
        Object.assign(hl.style, {
            display: 'block',
            left: r.left + 'px',
            top: r.top + 'px',
            width: r.width + 'px',
            height: r.height + 'px'
        });
        form.style.display = 'block';
        place(form, e.clientX, e.clientY);
        $('.comment').focus();
    }
    function startPicking() {
        picking = true;
        tip.style.display = 'none';
        hint.style.display = 'block';
        document.addEventListener('mousemove', onMove, true);
        document.addEventListener('click', onPick, true);
    }
    function stopPicking() {
        picking = false;
        hint.style.display = 'none';
        hl.style.display = 'none';
        document.removeEventListener('mousemove', onMove, true);
        document.removeEventListener('click', onPick, true);
    }
    function closeForm() {
        form.style.display = 'none';
        hl.style.display = 'none';
        $('.comment').value = '';
        target = null;
    }
    async function send() {
        const comment = $('.comment').value.trim();
        if (!comment) {
            $('.comment').focus();
            return;
        }
        const btn = $('.send');
        btn.disabled = true;
        btn.textContent = "Sending\u2026";
        const r = target.getBoundingClientRect();
        const name = $('.author').value.trim();
        const email = $('.email').value.trim();
        try {
            localStorage.setItem($65eb26a5e53d8e01$var$NAME_KEY, JSON.stringify({
                name: name,
                email: email
            }));
        } catch (e) {}
        try {
            const { pin: pin } = await $65eb26a5e53d8e01$var$request('POST', 'pins', {
                comment: comment,
                author_name: name || null,
                author_email: email || null,
                website: $('.website').value,
                page_url: $65eb26a5e53d8e01$var$pageUrl(),
                page_title: document.title.slice(0, 500),
                selector: (0, $ainy6.cssPath)(target),
                xpath: (0, $ainy6.xPath)(target),
                element_snippet: (target.outerHTML || '').slice(0, 2000),
                element_label: ((0, $ainy6.elementLabel)(target) || '').slice(0, 190),
                rect: {
                    x: r.left + window.scrollX,
                    y: r.top + window.scrollY,
                    width: r.width,
                    height: r.height
                },
                click: clickPt,
                viewport: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                    dpr: window.devicePixelRatio || 1,
                    scroll_x: window.scrollX,
                    scroll_y: window.scrollY
                },
                browser: {
                    user_agent: navigator.userAgent.slice(0, 500),
                    platform: (navigator.platform || '').slice(0, 120),
                    language: (navigator.language || '').slice(0, 30)
                },
                site_token: $65eb26a5e53d8e01$var$siteToken()
            });
            pins.push(pin);
            renderMarkers();
            closeForm();
            showToast('Thanks! Our team will review your feedback.');
        } catch (e) {
            showToast(e.status === 429 ? "Too many comments in a row \u2014 please wait a minute." : e.message || 'Could not send. Please try again.');
        } finally{
            btn.disabled = false;
            btn.textContent = 'Send feedback';
        }
    }
    function pinPoint(pin) {
        let el = null;
        try {
            el = pin.selector ? document.querySelector(pin.selector) : null;
        } catch (e) {}
        if (!el && pin.xpath) el = (0, $ainy6.resolveXPath)(pin.xpath);
        const xp = (pin.click?.x_pct ?? 50) / 100, yp = (pin.click?.y_pct ?? 50) / 100;
        if (el) {
            const r = el.getBoundingClientRect();
            if (r.width || r.height) return {
                x: r.left + r.width * xp,
                y: r.top + r.height * yp
            };
        }
        if (!pin.rect) return null;
        return {
            x: pin.rect.x - window.scrollX + pin.rect.width * xp,
            y: pin.rect.y - window.scrollY + pin.rect.height * yp
        };
    }
    function renderMarkers() {
        markersEl.innerHTML = '';
        pins.forEach((pin, i)=>{
            const pt = pinPoint(pin);
            if (!pt || pt.y < -30 || pt.y > window.innerHeight + 30) return;
            const m = document.createElement('div');
            m.className = 'marker' + (pin.status === 'approved' ? ' sent' : '');
            m.textContent = String(i + 1);
            m.style.left = pt.x + 'px';
            m.style.top = pt.y + 'px';
            m.addEventListener('mouseenter', ()=>showTip(pin, pt));
            m.addEventListener('click', ()=>showTip(pin, pt));
            m.addEventListener('mouseleave', ()=>{
                tip.style.display = 'none';
            });
            markersEl.appendChild(m);
        });
    }
    function showTip(pin, pt) {
        tip.textContent = '';
        const h = document.createElement('h4');
        h.textContent = pin.author_name ? `${pin.author_name}` : 'Client feedback';
        const p = document.createElement('div');
        p.textContent = pin.comment;
        const meta = document.createElement('div');
        meta.className = 'meta';
        meta.textContent = pin.status === 'approved' ? 'Sent to our team for changes' : 'Waiting for our team to review';
        tip.append(h, p, meta);
        tip.style.display = 'block';
        place(tip, pt.x, pt.y);
    }
    let raf = null;
    const reflow = ()=>{
        if (raf) return;
        raf = requestAnimationFrame(()=>{
            raf = null;
            renderMarkers();
        });
    };
    window.addEventListener('scroll', reflow, {
        passive: true
    });
    window.addEventListener('resize', reflow);
    $('.start').addEventListener('click', ()=>picking ? stopPicking() : (closeForm(), startPicking()));
    $('.cancel-pick').addEventListener('click', stopPicking);
    $('.cancel').addEventListener('click', closeForm);
    $('.send').addEventListener('click', send);
    root.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') {
            stopPicking();
            closeForm();
        }
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && picking) stopPicking();
    });
    $65eb26a5e53d8e01$var$request('GET', `pins?url=${encodeURIComponent($65eb26a5e53d8e01$var$pageUrl())}`).then((r)=>{
        pins = r.pins || [];
        renderMarkers();
    }).catch(()=>{});
}
function $65eb26a5e53d8e01$export$aeef28c7ed6d6680() {
    document.querySelectorAll($65eb26a5e53d8e01$var$TAG).forEach((el)=>el.remove());
}

});
parcelRegister("ainy6", function(module, exports) {

$parcel$export(module.exports, "cssPath", () => $77edda26aac7844b$export$a33ca12c106e2477);
$parcel$export(module.exports, "elementLabel", () => $77edda26aac7844b$export$66f53a4f0910c92a);
$parcel$export(module.exports, "xPath", () => $77edda26aac7844b$export$b3adfe77503c0699);
$parcel$export(module.exports, "resolveXPath", () => $77edda26aac7844b$export$bd3a7d56b25ab536);
$parcel$export(module.exports, "serializeDom", () => $77edda26aac7844b$export$3b021a86e7c2f107);
/**
 * Element anchoring + DOM snapshot capture for the site-review feedback bar.
 *
 * The snapshot is a self-contained HTML document of the page EXACTLY as the
 * reviewer saw it at click time (frozen carousel frame, open menus, typed
 * input values). The API renders it in real Chrome via Browserless for a
 * pixel-faithful screenshot — no html2canvas-style CSS misrendering.
 */ const $77edda26aac7844b$var$SNAPSHOT_MAX_CHARS = 3800000;
function $77edda26aac7844b$export$a33ca12c106e2477(el) {
    if (!(el instanceof Element)) return null;
    if (el.id && $77edda26aac7844b$var$isStableToken(el.id) && document.querySelectorAll('#' + CSS.escape(el.id)).length === 1) return '#' + CSS.escape(el.id);
    const segments = [];
    let node = el;
    let depth = 0;
    while(node && node.nodeType === 1 && node !== document.documentElement && depth < 14){
        let segment = node.tagName.toLowerCase();
        if (node.id && $77edda26aac7844b$var$isStableToken(node.id)) {
            segments.unshift('#' + CSS.escape(node.id));
            const candidate = segments.join(' > ');
            if ($77edda26aac7844b$var$matchesUnique(candidate, el)) return candidate;
            node = node.parentElement;
            depth++;
            continue;
        }
        const stableClasses = Array.from(node.classList).filter($77edda26aac7844b$var$isStableToken).slice(0, 3);
        if (stableClasses.length) segment += '.' + stableClasses.map((c)=>CSS.escape(c)).join('.');
        // Disambiguate against same-tag siblings when needed.
        const parent = node.parentElement;
        if (parent) {
            const sameTag = Array.from(parent.children).filter((c)=>c.tagName === node.tagName);
            if (sameTag.length > 1) segment += `:nth-of-type(${sameTag.indexOf(node) + 1})`;
        }
        segments.unshift(segment);
        const candidate = segments.join(' > ');
        if ($77edda26aac7844b$var$matchesUnique(candidate, el)) return candidate;
        node = node.parentElement;
        depth++;
    }
    const full = 'html > ' + segments.join(' > ');
    return $77edda26aac7844b$var$matchesUnique(full, el) ? full : segments.join(' > ');
}
function $77edda26aac7844b$var$matchesUnique(selector, el) {
    try {
        const found = document.querySelectorAll(selector);
        return found.length === 1 && found[0] === el;
    } catch (e) {
        return false;
    }
}
/**
 * Transient STATE classes — they move to a different element as the page runs
 * (carousel advance, menu toggle), so a selector built on one is only "unique"
 * for the frame it was captured in. Real case: `swiper-slide-active` baked
 * into a pin's selector pointed at whichever slide was active later.
 */ const $77edda26aac7844b$var$VOLATILE_TOKEN = new RegExp("^(active|inactive|current|selected|open|opened|closed|show|shown|hide|hidden|visible|collapsed|expanded|focus|focused|hover|animating|animated|in-view|w--current|elementor-active|is-(active|open|selected|visible|current|shown|hidden)|slick-(active|current|center|cloned)|swiper-slide-(active|next|prev|visible|fully-visible|duplicate(-\\w+)*)|owl-(active|current))$", 'i');
/**
 * Heuristic: skip machine-generated tokens (CSS-modules hashes, Elementor
 * element ids, utility soup) that won't survive a rebuild of the page, and
 * transient state classes that won't survive the next carousel tick.
 */ function $77edda26aac7844b$var$isStableToken(token) {
    if (!token || token.length > 40) return false;
    if ($77edda26aac7844b$var$VOLATILE_TOKEN.test(token)) return false;
    if (/\d{4,}/.test(token)) return false; // long digit runs (elementor-element-3f9a12)
    if (/^[a-z0-9]{8,}$/i.test(token) && /\d/.test(token) && !/[-_]/.test(token)) return false; // hash-like
    if (/^(css|jsx|sc)-/.test(token)) return false; // styled-components / css-modules
    return true;
}
function $77edda26aac7844b$export$66f53a4f0910c92a(el) {
    if (!(el instanceof Element)) return null;
    const text = (el.innerText || el.getAttribute('alt') || el.getAttribute('aria-label') || el.getAttribute('placeholder') || el.getAttribute('title') || '').trim().replace(/\s+/g, ' ').slice(0, 60);
    // Classify by the nearest SEMANTIC ancestor — a click on a button's inner
    // span is still "the button".
    const semantic = el.closest('a,button,[role="button"],input,select,textarea,label,h1,h2,h3,h4,h5,img,svg,video,iframe,nav,footer,header,form') || el;
    const tag = semantic.tagName.toLowerCase();
    const kinds = {
        a: 'Link',
        button: 'Button',
        input: 'Field',
        select: 'Dropdown',
        textarea: 'Field',
        label: 'Label',
        img: 'Image',
        svg: 'Icon',
        video: 'Video',
        iframe: 'Embed',
        nav: 'Navigation',
        footer: 'Footer',
        header: 'Header',
        form: 'Form',
        h1: 'Heading',
        h2: 'Heading',
        h3: 'Heading',
        h4: 'Heading',
        h5: 'Heading'
    };
    let kind = kinds[tag];
    if (!kind) kind = /button/i.test(semantic.className || '') ? 'Button' : el.tagName === 'P' || el.tagName === 'SPAN' ? 'Text' : 'Section';
    if (kind === 'Image') {
        const src = (semantic.getAttribute('src') || '').split('/').pop().split('?')[0].slice(0, 40);
        return text ? `Image \u{201C}${text}\u{201D}` : src ? `Image (${src})` : 'Image';
    }
    return text ? `${kind} \u{201C}${text}\u{201D}` : `${kind} <${el.tagName.toLowerCase()}>`;
}
function $77edda26aac7844b$export$b3adfe77503c0699(el) {
    if (!(el instanceof Element)) return null;
    const parts = [];
    let node = el;
    while(node && node.nodeType === 1){
        let index = 1;
        let sibling = node.previousElementSibling;
        while(sibling){
            if (sibling.tagName === node.tagName) index++;
            sibling = sibling.previousElementSibling;
        }
        parts.unshift(`${node.tagName.toLowerCase()}[${index}]`);
        node = node.parentElement;
    }
    return '/' + parts.join('/');
}
function $77edda26aac7844b$export$bd3a7d56b25ab536(xpath) {
    try {
        return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    } catch (e) {
        return null;
    }
}
function $77edda26aac7844b$export$3b021a86e7c2f107(excludeRoots = []) {
    try {
        // Tag stylesheet owner nodes so we can find them in the clone, then
        // clean the attributes up afterwards.
        const styleOwners = [];
        Array.from(document.styleSheets).forEach((sheet, i)=>{
            if (sheet.ownerNode && sheet.ownerNode.setAttribute) {
                sheet.ownerNode.setAttribute('data-kmd-css', String(i));
                styleOwners.push(sheet.ownerNode);
            }
        });
        const clone = document.documentElement.cloneNode(true);
        try {
            $77edda26aac7844b$var$syncTrees(document.documentElement, clone, excludeRoots);
            $77edda26aac7844b$var$inlineStylesheets(clone);
        } finally{
            styleOwners.forEach((n)=>n.removeAttribute('data-kmd-css'));
        }
        const head = clone.querySelector('head') || clone;
        // Resolve any leftover relative URLs (inline style url(...), etc.).
        const base = document.createElement('base');
        base.setAttribute('href', document.baseURI);
        head.insertBefore(base, head.firstChild);
        // Freeze animations so the render settles deterministically.
        const freeze = document.createElement('style');
        freeze.textContent = '*,*::before,*::after{animation:none!important;transition:none!important;cursor:auto!important}';
        head.appendChild(freeze);
        const html = '<!DOCTYPE html>\n' + clone.outerHTML;
        return html.length > $77edda26aac7844b$var$SNAPSHOT_MAX_CHARS ? null : html;
    } catch (e) {
        return null;
    }
}
/**
 * Walk the original and cloned trees in lockstep (cloneNode preserves
 * structure) copying live state the clone can't carry, absolutizing URLs,
 * and marking nodes to strip. Removals happen after the walk so the two
 * trees stay parallel throughout.
 */ function $77edda26aac7844b$var$syncTrees(orig, clone, excludeRoots) {
    const toRemove = [];
    const stack = [
        [
            orig,
            clone
        ]
    ];
    while(stack.length){
        const [o, c] = stack.pop();
        if (!o || !c || o.nodeType !== 1) continue;
        const tag = o.tagName;
        if (excludeRoots.includes(o) || tag === 'SCRIPT' || tag === 'NOSCRIPT') {
            toRemove.push(c);
            continue;
        }
        if (tag === 'IFRAME' || tag === 'OBJECT' || tag === 'EMBED') {
            const rect = o.getBoundingClientRect();
            const ph = document.createElement('div');
            ph.style.cssText = `width:${rect.width}px;height:${rect.height}px;background:#f3f4f6;border:1px dashed #cbd5e1;box-sizing:border-box;display:inline-block;`;
            if (c.parentNode) c.parentNode.replaceChild(ph, c);
            continue;
        }
        if (tag === 'INPUT') {
            if (o.type === 'checkbox' || o.type === 'radio') {
                if (o.checked) c.setAttribute('checked', '');
                else c.removeAttribute('checked');
            } else if (o.type !== 'password') c.setAttribute('value', o.value);
            else c.setAttribute('value', o.value ? "\u2022\u2022\u2022\u2022\u2022\u2022" : '');
        } else if (tag === 'TEXTAREA') c.textContent = o.value;
        else if (tag === 'SELECT') {
            const options = o.querySelectorAll('option');
            const cloneOptions = c.querySelectorAll('option');
            options.forEach((opt, i)=>{
                if (cloneOptions[i]) {
                    if (opt.selected) cloneOptions[i].setAttribute('selected', '');
                    else cloneOptions[i].removeAttribute('selected');
                }
            });
        } else if (tag === 'CANVAS') try {
            const img = document.createElement('img');
            img.src = o.toDataURL();
            img.width = o.width;
            img.height = o.height;
            if (o.getAttribute('style')) img.setAttribute('style', o.getAttribute('style'));
            if (o.getAttribute('class')) img.setAttribute('class', o.getAttribute('class'));
            if (c.parentNode) c.parentNode.replaceChild(img, c);
            continue;
        } catch (e) {}
        // Absolutize resource URLs via the live element's resolved properties.
        if (tag === 'IMG') {
            if (o.currentSrc || o.src) c.setAttribute('src', o.currentSrc || o.src);
            c.removeAttribute('srcset');
            c.removeAttribute('loading'); // lazy images must load in the renderer
        } else if (tag === 'SOURCE') {
            if (o.src) c.setAttribute('src', o.src);
            c.removeAttribute('srcset');
        } else if ((tag === 'VIDEO' || tag === 'AUDIO') && o.src) {
            c.setAttribute('src', o.src);
            c.removeAttribute('autoplay');
        } else if (tag === 'LINK' && o.href) c.setAttribute('href', o.href);
        const oc = o.children;
        const cc = c.children;
        // Children may diverge if a replacement already happened — pair by index defensively.
        for(let i = 0; i < oc.length && i < cc.length; i++)stack.push([
            oc[i],
            cc[i]
        ]);
    }
    toRemove.forEach((n)=>n.parentNode && n.parentNode.removeChild(n));
}
/**
 * Replace readable (same-origin) stylesheet links in the clone with their
 * current rules — this captures CSSOM state and avoids re-fetch drift.
 * Cross-origin sheets stay as absolutized <link>s for the renderer to fetch.
 */ function $77edda26aac7844b$var$inlineStylesheets(clone) {
    Array.from(document.styleSheets).forEach((sheet, i)=>{
        const cloneNode = clone.querySelector(`[data-kmd-css="${i}"]`);
        if (!cloneNode) return;
        cloneNode.removeAttribute('data-kmd-css');
        let cssText = null;
        try {
            cssText = Array.from(sheet.cssRules).map((r)=>r.cssText).join('\n');
        } catch (e) {
            return; // cross-origin — the absolutized <link> stays
        }
        if (cloneNode.tagName === 'LINK') {
            const style = document.createElement('style');
            style.textContent = $77edda26aac7844b$var$resolveCssUrls(cssText, sheet.href || document.baseURI);
            cloneNode.parentNode.replaceChild(style, cloneNode);
        } else // <style> node: refresh with CSSOM state (rules may have been mutated at runtime).
        cloneNode.textContent = $77edda26aac7844b$var$resolveCssUrls(cssText, document.baseURI);
    });
}
/** url(foo.png) inside an inlined sheet resolves against the SHEET's URL, not the page. */ function $77edda26aac7844b$var$resolveCssUrls(cssText, baseHref) {
    return cssText.replace(/url\(\s*(['"]?)([^'")]+)\1\s*\)/g, (match, quote, url)=>{
        if (/^(data:|blob:|https?:|\/\/|#)/i.test(url)) return match;
        try {
            return `url("${new URL(url, baseHref).href}")`;
        } catch (e) {
            return match;
        }
    });
}

});


/**
 * Standalone entry for KHERD-Client — the limited, public feedback bar on a client's
 * STAGING site. Enqueued by the WordPress plugin on *.pilotpractice.cloud hosts only,
 * never on a live domain (Roy, 2026-10-22, task 182083).
 */ 
var $8KvCN = parcelRequire("8KvCN");
(0, $8KvCN.initClientFeedback)();

})();
//# sourceMappingURL=client-feedback.js.map
